import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: '54a3d259-c772-4dff-a81f-199d649bc42d',
    authority: 'https://login.microsoftonline.com/organizations',
    // Must match exactly what's registered in Azure (Authentication ->
    // Single-page application -> Redirect URIs) — no trailing slash.
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message) => {
        if (level === 'Error') console.error('[MSAL]', message);
      },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
  // Without this, MSAL silently continues with whatever Microsoft account
  // already has an active browser session (SSO) — fine most of the time,
  // but wrong the moment someone needs to log in as a different account
  // than the one Windows/Edge is currently signed into. This forces
  // Microsoft's account picker every time instead.
  prompt: 'select_account',
};

export const msalInstance = new PublicClientApplication(msalConfig);
